module.exports = __webpack_public_path__ + "media/images/payments/maestro-bdb53b3598f481db088ee173ecbcc90e.svg";